import { useEffect } from 'react';
import { useFormik } from 'formik';
import { PqrTime } from '../../../../../../shared/types/paramPqrTimes';
import { useGetNameOrValue } from '../../../../../../shared/utils/useGetNameOrValue';

export const usePqrTimesData = (data?: PqrTime) => {
    const formik = useFormik({
        initialValues: {
            receptionChannel: '',
            type: '',
            typeDay: '',
            name: '',
            half: '',
            status: '',
            subtypeDp: '',
            procedure: '',
            observation: '',
            active: true,
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        formik.setValues({
            receptionChannel: useGetNameOrValue(data?.receptionChannel || ''),
            type: useGetNameOrValue(data?.type || ''),
            typeDay: useGetNameOrValue(data?.typeDay || ''),
            half: useGetNameOrValue(data?.half || ''),
            name: useGetNameOrValue(data?.name || ''),
            status: useGetNameOrValue(data?.status || ''),
            subtypeDp: useGetNameOrValue(data?.subtypeDp || ''),
            procedure: useGetNameOrValue(data?.procedure || ''),
            observation: data?.observation || '',
            active: data?.active ?? false,
        });
    }, [data]);

    return {
        formik,
    };
};
